// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"95867140","172":"f5747a64"}[chunkId] + ".chunk.js";
};